import styled from 'styled-components';
import { media, spacing } from '@storefront/lib-global/stylings';

export const ProductFeaturesWrapper = styled.section`
  margin-block: 20px;
  padding: 0;

  > ul {
    display: flex;
    flex-wrap: wrap;
    gap: ${spacing.M};
    justify-content: flex-start;
    margin: 0;
    padding: 0;

    @media ${media.greaterThan('lg')} {
      gap: 37px;
      justify-content: center;
      max-width: 523px;
      padding: 0 20px 0 18px;
    }
  }

  @media ${media.greaterThan('lg')} {
    margin-block: 38px;
  }
`;
